import { createWhopFetch } from "../api/index.js";
import { apiBaseUrl } from "../auth/client.js";
import { responseError, whopApiFetch } from "../lib/http.js";

const PLACEHOLDER = "https://api.whop.com";
const proxyFetch = createWhopFetch();

/**
 * Thin wrapper around the API fetch proxy for hand-written commands. The proxy
 * strips the host and uses apiBaseUrl() internally, auto-fills the active
 * account, and normalizes errors to a top-level `message` — so we only need the
 * pathname (a query string in `path` is fine) and can surface `message` directly.
 */
export async function makeWhopRequest<T>(
	method: "GET" | "POST" | "PATCH" | "DELETE",
	path: string,
	body?: Record<string, unknown>,
	accessToken?: string,
): Promise<T> {
	const init: RequestInit = { method };
	if (body !== undefined) init.body = JSON.stringify(body);
	const res = accessToken
		? await whopApiFetch(
				`${apiBaseUrl().replace(/\/$/, "")}${path}`,
				accessToken,
				{
					...init,
					headers:
						body !== undefined ? { "Content-Type": "application/json" } : {},
				},
			)
		: await proxyFetch(new Request(`${PLACEHOLDER}${path}`, init));

	if (!res.ok) throw await responseError(res);

	// DELETE (and other 204s) can return an empty body, which `res.json()` would
	// reject — treat an empty body as a successful, content-less response.
	const text = await res.text();
	return (text ? JSON.parse(text) : { success: true }) as T;
}
